module.exports = __webpack_public_path__ + "img/educacao_empreendedora_bronze.544e2e62.png";